import { render } from "./danhBacWedding.vue?vue&type=template&id=05506f82"
import script from "./danhBacWedding.vue?vue&type=script&lang=js"
export * from "./danhBacWedding.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__